import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePhone, faAddressCard, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const ContactInfoSection = () => {
  return (
    <section className="section-002cnt">
      <div className="container">
        <div className="inner-content">
          <div className="row-wrapper">
            <div className="main-listing">
              <div className="content-wrap">
                <div className="img-box">
                  <FontAwesomeIcon icon={faSquarePhone} />
                </div>
                <div className="text-wrap">
                  <span>+1 (416) 500-1535</span>
                </div>
              </div>
            </div>
            {/* <div className="main-listing">
              <div className="content-wrap">
                <div className="img-box">
                  <i class="fa-solid fa-location-dot"></i>
                </div>
                <div className="text-wrap">
                  <a href="">
                  Visit Us: Fallview Cir, Caledon, Canada</a>
                  <h6>CA 94123</h6>
                </div>
              </div>
            </div> */}
            <div className="main-listing">
              <div className="content-wrap">
                <div className="img-box">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <div className="text-wrap">
                  <span>technoinspections@gmail.com</span>
                  <h6>Contact us every time!</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
